import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { ConfigureMetricsForm } from '@ui/components/Forms';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { configureScoreMetrics, setIsMetricConfigured } from '@application/redux/scoreCard/score-card-slice';
const ConfigureMetrics = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const handleSubmitChange = () => {
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };
    const handleFormSubmit = async (data) => {
        dispatch(configureScoreMetrics({ metrics: data.metrics }))
            .unwrap()
            .then((response) => {
            toast.success(response.message);
            setIsMetricConfigured();
        })
            .catch((error) => {
            toast.error(error);
        });
    };
    const handleClose = () => {
        onClose();
    };
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', slotProps: {
            paper: {
                sx: {
                    width: '564px'
                }
            }
        }, fullWidth: true, "aria-labelledby": 'ConfDialog', onKeyDown: (e) => e.key === 'Enter' && {}, children: [_jsxs(DialogTitle, { id: 'add-vehicle-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsx(Typography, { variant: 'h6', color: 'text.primary', children: t('ConfigureMetrics') }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(ConfigureMetricsForm, { ref: formRef, assetId: '86AAC17D-397E-404F-9242-C4F1F2052B34', onSubmitHandler: handleFormSubmit }) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: handleSubmitChange, variant: 'contained', color: 'inherit', loading: false, type: 'submit', children: t('Save') }), _jsx(Button, { onClick: handleClose, color: 'inherit', variant: 'outlined', children: "Cancel" })] })] }));
};
export default ConfigureMetrics;
